import { useState } from "react";

export const useCheck = ({ value = false }) => {
  const [checked, setChecked] = useState(value);
  const [datable, setDatable] = useState(false);

  const onChange = (event) => {
    if (event.timeStamp) setDatable(event.target.checked);
    
    setChecked(event.target.checked);
  };

  return {
    checked,
    datable,
    onChange,
  };
};
